import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-awards-nav',
  templateUrl: './awards-nav.component.html',
  styleUrls: ['./awards-nav.component.scss']
})
export class AwardsNavComponent implements OnInit {


  @Input() page = '';

  

  constructor() { }

  ngOnInit(): void {

    // let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;

    // element.click();

  }

}
